
export const check_filters = (product, filter, lines) => {
  let filter_passed = true;
  if (filter.query !== undefined && filter.query !== null)
    filter_passed = JSON.stringify(product).toLowerCase()
    .includes(filter.query.toLowerCase());
  if (!filter.selected)
    return filter_passed;
  return filter_passed && productIsInLines(product, lines);
}

function productIsInLines(product, lines) {
  return Object.keys(lines).includes(product.generic);
}